import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IPerformance } from "../../../Pages/DashboardUserStudent/IDashboardUserStudent";

export const ListPerformanceSlice = createSlice({
  name: "ListPerformanceSlice",
  initialState: {} as IReduxState<IPerformance[]>,
  reducers: {
    listPerformance: (state, _: PayloadAction<IPerformance>) => {
      state.isLoading = true;
    },
    successlistPerformance: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failurelistPerformance: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  failurelistPerformance,
  listPerformance,
  successlistPerformance,
} = ListPerformanceSlice.actions;

export default ListPerformanceSlice.reducer;
